import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M12 5C12 3.375 13.3125 2 15 2H17C18.625 2 20 3.375 20 5V27C20 28.6875 18.625 30 17 30H15C13.3125 30 12 28.6875 12 27V5ZM2 17C2 15.375 3.3125 14 5 14H7C8.625 14 10 15.375 10 17V27C10 28.6875 8.625 30 7 30H5C3.3125 30 2 28.6875 2 27V17ZM27 6C28.625 6 30 7.375 30 9V27C30 28.6875 28.625 30 27 30H25C23.3125 30 22 28.6875 22 27V9C22 7.375 23.3125 6 25 6H27Z'],
  name: 'uiChartSimpleSolid'
} as IconDefinition
